import { render, staticRenderFns } from "./PersonCount.vue?vue&type=template&id=b2d063c0&"
import script from "./PersonCount.vue?vue&type=script&lang=js&"
export * from "./PersonCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports